<template>
    <div>
      <h4 style="padding-left: 20px;">委托单号：{{testEntrust.orderNo}}</h4>
      <el-form :model="paymentInfo" label-width="120px" size="small">
        <el-card shadow="never" style="margin-top: 20px;">
          <div slot="header" class="clearfix">
            <span>检验报告邮寄地址</span>
          </div>
          <div>
            <p>发送方式： {{testEntrust.reportSend}}</p>
            <p v-if="testEntrust.reportSendCode === '1'">邮寄地址： {{paymentInfo.toAddressee}}  {{paymentInfo.toAddress}}  {{paymentInfo.toMobile}}</p>
            <el-button v-if="testEntrust.reportSendCode === '1'" plain @click="changeAddress('payment')">更换地址</el-button>
          </div>
        </el-card>
        <el-dialog
          title="选择收货地址"
          :visible.sync="showAddressSel"
          :destroy-on-close = "true"
          width="50%">
          <select-address ref="addressDia"></select-address>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showAddressSel = false">取 消</el-button>
            <el-button type="primary" @click="handleSelectAddress">确 定</el-button>
          </span>
        </el-dialog>
        <el-card shadow="never" style="margin-top: 20px;">
          <div slot="header" class="clearfix">
            <span>检验费用</span>
          </div>
          <div>
            <el-table border
                      :data="testEntrustDetailsEditList">
              <el-table-column
                label="序号"
                align="center"
                type="index"
                width="80">
              </el-table-column>
              <el-table-column
                prop="productName"
                label="产品/方法"
                width="150">
                <template slot-scope="scope">
                  {{scope.row.productName}}<span v-if="scope.row.refineFullName" style="color: red">[{{scope.row.refineFullName}}]</span>
                  <!--            <el-tag v-if="scope.row.itemIsGb === '1'" size="mini" type="success" style="margin-left: 5px;">国标</el-tag>-->
                  <!--            <el-tag v-if="scope.row.itemIsGb === '0'" size="mini" type="success" style="margin-left: 5px;">企标</el-tag>-->
                </template>
              </el-table-column>
              <el-table-column
                prop="standardName"
                label="检测标准"
                width="280">
              </el-table-column>
              <el-table-column
                prop="itemNames"
                label="检验项目">
              </el-table-column>
              <el-table-column
                label="价格"
                align="center"
                prop="price"
                width="150">
              </el-table-column>
            </el-table>
            <div style="text-align: right;width: 100%;">
              <div class="payment-calculate">
                <div>{{testEntrust.itemNum}}个检验项目，检验费用：<span class="money-text">{{testEntrust.itemsPrice}}</span>元</div>
                <div>{{testEntrust.cycle}}：<span class="money-text">{{testEntrust.cyclePrice}}</span>元</div>
                <div>{{testEntrust.reportType}}（{{testEntrust.reportForm}}）：<span class="money-text">{{testEntrust.reportPrice}}</span>元</div>
                <div>邮费：<span class="money-text">{{testEntrust.sendPrice}}</span>元</div>
                <el-divider></el-divider>
                  <div style="font-weight: bold">应支付费用：<span class="money-text">{{(testEntrust.rawPrice + testEntrust.discountPrice).toFixed(2)}}</span>元</div>
                <div style="color: #E6A23C">优惠：<span class="money-text">{{testEntrust.discountPrice}}</span>元</div>
              </div>
            </div>
            <el-divider></el-divider>
            <el-form-item label="总费用：" prop="cycle">
              <span v-if="vipInfo" style="position: relative">
                 <span style="width: 180px;color: red;font-size: 28px;" size="medium">{{testEntrust.sumPrice}}</span>
                <span style="margin-left: 10px;">元</span>
                <del size="medium" style="position: relative;top:15px;width: 180px;font-size: 12px;">原价{{testEntrust.rawPrice}}元</del>
              </span>
              <span v-if="!vipInfo" style="position: relative">
                 <span style="width: 180px;color: red;font-size: 28px;" size="medium">{{testEntrust.sumPrice}}</span>
                <span style="margin-left: 10px;">元</span>
                <span size="medium" style="position: relative;top:15px;width: 180px;font-size: 12px;color:red">会员{{testEntrust.vipSumPrice}}元</span>
              </span>
              <el-button style="margin-left: 20px;" plain @click="getTestEntrustResponse">刷新金额</el-button>
            </el-form-item>
            <el-form-item label="付款方式：" prop="payType">
              <el-radio-group v-model="paymentInfo.payType">
                <el-radio border v-for="(item) in selectOptions.paymentOptions" :key="item.code" :label="item.code">{{item.name}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-card>
        <el-card shadow="never" style="margin-top: 20px;">
          <div slot="header" class="clearfix">
            <span>发票信息</span>
          </div>
          <div>
            <el-form-item label="发票类型：" prop="invoiceType">
              <el-radio-group v-model="paymentInfo.invoiceType" @change="channgeInvoiceType">
                <el-radio border v-for="(item) in commonUtils.getDictPara('invoice_type')" :key="item.code" :label="item.code">{{item.name}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="paymentInfo.invoiceType !== '1'" label="发票抬头：">
              <el-button plain @click="showInvoiceSel = true">更换发票抬头</el-button>
            </el-form-item>
            <el-dialog
              title="选择发票抬头"
              :visible.sync="showInvoiceSel"
              :destroy-on-close = "true"
              width="50%">
              <select-invoice ref="selInvoice"></select-invoice>
              <span slot="footer" class="dialog-footer">
                <el-button @click="showInvoiceSel = false">取 消</el-button>
                <el-button type="primary" @click="handleInvoiceAddress">确 定</el-button>
              </span>
            </el-dialog>
            <el-row v-if="paymentInfo.invoiceType !== '1'" style="width: 80%">
              <el-col :span="12">
                <el-form-item label="">
                  <span slot="label"><span style="color:red">*</span>名称：</span>
                  {{paymentInfo.invoiceName}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="">
                  <span slot="label"><span style="color:red">*</span>纳税人识别号：</span>
                  {{paymentInfo.invoiceTaxNumber}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="地址：">
                  <span slot="label"><span style="color:red" v-if="paymentInfo.invoiceType === '3'">*</span>地址：</span>
                  {{paymentInfo.invoiceAddress}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="">
                  <span slot="label"><span style="color:red">*</span>电话：</span>
                  {{paymentInfo.invoicePhone}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="">
                  <span slot="label"><span style="color:red" v-if="paymentInfo.invoiceType === '3'">*</span>开户行：</span>
                  {{paymentInfo.invoiceBankName}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="银行账号：">
                  {{paymentInfo.invoiceBankNo}}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="邮寄地址：">
                  {{paymentInfo.invoiceToAddressee}}  {{paymentInfo.invoiceToAddress}}  {{paymentInfo.invoiceToMobile}}
                  <el-button size="small" plain @click="changeAddress('invoice')">更换地址</el-button>
                </el-form-item>
                <div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-form>
      <el-divider></el-divider>
      <div class="clearfix" style="text-align: center">
        <el-button size="medium" type="warning" @click="handleBack">返回上一页</el-button>
        <el-button size="medium" type="warning" @click="handleSavePause">暂存</el-button>
        <!--<el-button size="medium" type="success" @click="handleSaveNext">确定支付</el-button>-->
        <el-button size="medium" type="success" @click="handleSaveNext" v-if="paymentInfo.examineState === '0' || testInspectionOrgEdit.needCheck !== '1'">确定支付</el-button>
        <el-button size="medium" type="success" @click="handleWaitExam" v-if="paymentInfo.examineState !== '0' && testInspectionOrgEdit.needCheck === '1'">提交审核</el-button>
      </div>
    </div>
</template>

<script>
import { getTestEntrustResponse, saveTestEntrustPayment } from '@/api/test/entrust'
import SelectAddress from './select-address'
import SelectInvoice from './select-invoice'
import { list } from '@/api/user/userInvoice'

export default {
  name: 'payment-info',
  components: { SelectInvoice, SelectAddress },
  props: {
    entrustId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      pause: true,
      testEntrust: {},
      showAddressSel: false,
      AddressSelType: '',
      showInvoiceSel: false,
      productItemDataList: [],
      testEntrustDetailsEditList: [],
      testEntrustEnt: {},
      testInspectionOrgEdit: {
        needCheck: '0'
      },
      selectOptions: {
        paymentOptions: []
      },
      invoice: {
        invoiceAddress: '',
        invoiceBankName: '',
        invoiceBankNo: '',
        invoiceName: '',
        invoicePhone: '',
        invoiceTaxNumber: ''
      },
      paymentInfo: {
        invoiceType: '1',
        payType: '0',
        invoiceAddress: '',
        invoiceBankName: '',
        invoiceBankNo: '',
        invoiceName: '',
        invoicePhone: '',
        invoiceTaxNumber: '',
        orderRemark: ''
      },
      testProjectData: []
    }
  },
  computed: {
    vipInfo () {
      return this.$store.state.user.vipInfo
    }
  },
  mounted () {
    this.selectOptions.paymentOptions = this.commonUtils.getDictPara('pay_type')
    this.getTestEntrustResponse()
    this.initInvoice()
    this.paymentInfo.entrustId = this.entrustId
  },
  methods: {
    getTestEntrustResponse () {
      let param = { entrustId: this.entrustId }
      getTestEntrustResponse(param).then(res => {
        var result = res.data
        if (result.rtnCode === '0') {
          if (result.bizData.productItemDataList) {
            this.productItemDataList = result.bizData.productItemDataList
          }
          if (result.bizData.testInspectionOrgEdit) {
            this.testInspectionOrgEdit = result.bizData.testInspectionOrgEdit
            let newArr = []
            this.selectOptions.paymentOptions.forEach(v => {
              if (v.code === '0' && this.testInspectionOrgEdit.wxAppId) {
                newArr.push(v)
              } else if (v.code === '1' && this.testInspectionOrgEdit.apAppId) {
                newArr.push(v)
              } else if (v.code === '2') {
                newArr.push(v)
              }
            })
            this.selectOptions.paymentOptions = newArr
            if (newArr.length > 0) {
              this.paymentInfo.payType = newArr[0].code
            }
          }
          if (result.bizData.testEntrust) {
            this.testEntrust = result.bizData.testEntrust
            this.paymentInfo.examineState = this.testEntrust.examineState
            this.paymentInfo.toAddress = this.testEntrust.toAddress
            this.paymentInfo.toAddressee = this.testEntrust.toAddressee
            this.paymentInfo.toMobile = this.testEntrust.toMobile
            this.paymentInfo.invoiceAddress = this.testEntrust.invoiceAddress
            this.paymentInfo.invoiceBankName = this.testEntrust.invoiceBankName
            this.paymentInfo.invoiceBankNo = this.testEntrust.invoiceBankNo
            this.paymentInfo.invoiceName = this.testEntrust.invoiceName
            this.paymentInfo.invoicePhone = this.testEntrust.invoicePhone
            this.paymentInfo.invoiceTaxNumber = this.testEntrust.invoiceTaxNumber
            this.paymentInfo.invoiceToAddressee = this.testEntrust.invoiceToAddressee
            this.paymentInfo.invoiceToAddress = this.testEntrust.invoiceToAddress
            this.paymentInfo.invoiceToMobile = this.testEntrust.invoiceToMobile
            this.paymentInfo.orderRemark = this.testEntrust.orderRemark
            this.paymentInfo.handelPart = this.testEntrust.handelPart
            if (this.testEntrust.invoiceType) {
              this.paymentInfo.invoiceType = this.testEntrust.invoiceType
            }
            if (this.testEntrust.payType) {
              this.paymentInfo.payType = this.testEntrust.payType
            }
          }
          if (result.bizData.testEntrustDetailsEditList) {
            this.testEntrustDetailsEditList = result.bizData.testEntrustDetailsEditList
          }
          if (result.bizData.testEntrustEnt) {
            this.testEntrustEnt = result.bizData.testEntrustEnt
          }
        } else {
          this.$message.error(result.bizMsg)
        }
      }).catch(() => {
        this.$message.error('加载失败')
      })
    },
    handleBack () {
      this.$emit('back')
    },
    handleSaveNext () {
      this.handleSave('next')
    },
    handleSavePause () {
      this.pause = true
      this.handleSave('pause')
    },
    handleSave (type) {
      if (type === 'next') {
        if (this.paymentInfo.invoiceType === '3' && (!this.paymentInfo.invoiceAddress || !this.paymentInfo.invoiceBankName)) {
          this.$message.error('开专票时开户行和地址必须填写')
          return
        }
        this.paymentInfo.handelPart = '2'
      } else {
        this.paymentInfo.handelPart = '2'
      }
      saveTestEntrustPayment(this.paymentInfo)
        .then(res => {
          this.loading = false
          var result = res.data
          if (result.rtnCode !== '0') {
            this.$message({
              type: 'info',
              message: result.msg
            })
          } else {
            if (type === 'pause') {
              this.$router.push({
                path: 'userCenter/myEntrust?st=1'
              })
            } else {
              this.$emit('next', null, result.bizData)
            }
          }
        }).catch(ex => {
          this.loading = false
          this.$message.error('保存失败，请稍后再试！')
        })
    },
    handleWaitExam () {
      if (this.paymentInfo.invoiceType === '3' && (!this.paymentInfo.invoiceAddress || !this.paymentInfo.invoiceBankName)) {
        this.$message.error('开专票时开户行和地址必须填写')
        return
      }
      this.paymentInfo.handelPart = '2'
      // 待审核
      this.paymentInfo.examineState = '2'
      saveTestEntrustPayment(this.paymentInfo)
        .then(res => {
          this.loading = false
          var result = res.data
          if (result.rtnCode !== '0') {
            this.$message({
              type: 'info',
              message: result.msg
            })
          } else {
            this.$emit('nextNum', 5, this.entrustId)
          }
        }).catch(ex => {
          this.loading = false
          this.$message.error('保存失败，请稍后再试！')
        })
    },
    channgeInvoiceType () {
      if (!this.paymentInfo.invoiceName) {
        this.paymentInfo.invoiceAddress = this.invoice.invoiceAddress
        this.paymentInfo.invoiceBankName = this.invoice.invoiceBankName
        this.paymentInfo.invoiceBankNo = this.invoice.invoiceBankNo
        this.paymentInfo.invoiceName = this.invoice.invoiceName
        this.paymentInfo.invoicePhone = this.invoice.invoicePhone
        this.paymentInfo.invoiceTaxNumber = this.invoice.invoiceTaxNumber
      }
    },
    initInvoice () {
      let param = {}
      param.page = {
        pageNum: 1,
        pageSize: 1
      }
      list(param).then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          if (result.bizData && result.bizData.length > 0) {
            this.invoice.invoiceAddress = result.bizData[0].address
            this.invoice.invoiceBankName = result.bizData[0].bank
            this.invoice.invoiceBankNo = result.bizData[0].bankAccount
            this.invoice.invoiceName = result.bizData[0].title
            this.invoice.invoicePhone = result.bizData[0].mobile
            this.invoice.invoiceTaxNumber = result.bizData[0].taxNumber
          }
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    },
    changeAddress (stype) {
      this.AddressSelType = stype
      this.showAddressSel = true
    },
    handleSelectAddress () {
      this.showAddressSel = false
      if (this.AddressSelType === 'payment') {
        this.paymentInfo.toAddress = this.$refs['addressDia'].selectAddress.toAddress
        this.paymentInfo.toAddressee = this.$refs['addressDia'].selectAddress.toAddressee
        this.paymentInfo.toMobile = this.$refs['addressDia'].selectAddress.toMobile
      } else if (this.AddressSelType === 'invoice') {
        this.paymentInfo.invoiceToAddressee = this.$refs['addressDia'].selectAddress.toAddress
        this.paymentInfo.invoiceToAddress = this.$refs['addressDia'].selectAddress.toAddressee
        this.paymentInfo.invoiceToMobile = this.$refs['addressDia'].selectAddress.toMobile
      }
    },
    handleInvoiceAddress () {
      this.showInvoiceSel = false
      this.paymentInfo.invoiceAddress = this.$refs['selInvoice'].selectInvoice.invoiceAddress
      this.paymentInfo.invoiceBankName = this.$refs['selInvoice'].selectInvoice.invoiceBankName
      this.paymentInfo.invoiceBankNo = this.$refs['selInvoice'].selectInvoice.invoiceBankNo
      this.paymentInfo.invoiceName = this.$refs['selInvoice'].selectInvoice.invoiceName
      this.paymentInfo.invoicePhone = this.$refs['selInvoice'].selectInvoice.invoicePhone
      this.paymentInfo.invoiceTaxNumber = this.$refs['selInvoice'].selectInvoice.invoiceTaxNumber
    }
  }
}
</script>

<style lang="scss" scoped>
  .money-text{
    display: inline-block;
    width: 70px;
  }
  .payment-calculate{
    width: 50%;
    margin-left: auto;
    text-align: right;
    div{
      margin: 5px 0;
    }
  }
</style>
